import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { PageHero } from '../../../components/pageHero/PageHero';
import { endpoints } from 'endpoints.config';
import { InfoTable } from 'components/infoTable/infoTable';
import { DeleteRecordsPopup } from '../../../pages/wondeIntegration/wIPopups/DeleteRecordsPopup';
import { PreviouslyMatchedRecords } from '../wIFeatures/PreviouslyMatchedRecords';
import { SyncDataOption } from '../WondeIntegration';
import { Spinner } from 'components/spinner/Spinner';

type WIStep4Props = {
  setWondeIntegration: Dispatch<SetStateAction<boolean>>;
  currentSynOpt: string;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  syncDataOpts: SyncDataOption[];
  setSyncDataOpts: Dispatch<SetStateAction<SyncDataOption[]>>;
};

export const WIStep4: React.FC<WIStep4Props> = ({ 
  setWondeIntegration,
  currentSynOpt,
  setCurrentStep,
  syncDataOpts,
  setSyncDataOpts,
}) => {
  const [checkTableLoading, setCheckTableLoading] = useState<any>(false);
  const [listUrl, setListUrl] = useState<string>("");
  const [submitUrl, setSubmitUrl] = useState<string>("");   
  const [pageName, setPageName] = useState<string | null>(null);
  const [recordsSelected, setRecordsSelected] = useState<any>([]);
  const [isPanelClosed, setIsPanelClosed] = useState<boolean>(true);
  const [deleteRecordsPopupOpen, setDeleteRecordsPopupOpen] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>([]);
  const [endpointTableErr, setEndpointTableErr] = useState<boolean>(false);

  useEffect(() => {
    document.body.style.overflowY = '';
  }, []); 

  useEffect(() => {
    if(currentSynOpt){
      loadData();
    }
  }, [currentSynOpt]);

  useEffect(() => {
    if(endpointTableErr){
      const updatedSyncDataOpts = syncDataOpts.slice(1);

      window.scrollTo(0, 0);
      setDeleteRecordsPopupOpen(false);          
  
      if(updatedSyncDataOpts.length > 0){            
        setSyncDataOpts(updatedSyncDataOpts);
        setCurrentStep(1);
      } else {
        setWondeIntegration(false);
      }
    }
  }, [endpointTableErr]);  

  const loadData = async () => {
    setPageName(`Sync ${currentSynOpt} Records`);

    const currentListUrl = currentSynOpt === "Class" ?
      endpoints.wondeIntegration.classStep4List :
      endpoints.wondeIntegration.pupilStep4List;

    setListUrl(currentListUrl);

    const currentSubmitUrl = currentSynOpt === "Class" ?
      endpoints.wondeIntegration.classStep4UnmatchedClassesDelete :
      endpoints.wondeIntegration.pupilStep4UnmatchedClassesDelete;

    setSubmitUrl(currentSubmitUrl);
  };

  return (
    <div className="PageContent WondeIntegrationPage Step4">
      <PageHero title={pageName ?? ''} />
      <div className="WidthContent">
        {checkTableLoading &&
          <div className="LoadingPanel">
            <div className="LPInfo">
              <Spinner />
              <div className="LPTxt">Hang tight...we are just checking your data!</div>
            </div>
          </div>
        }

        <div className="TopInfoRow">
          <div className="LeftSide">
            <h2>Remaining Get Set 4 Education Records</h2>
          </div>
          <div className="RightSide">
            {/*<p>Step 4 of 4</p>*/}
          </div>
        </div>
        <p>Here are the remaining records that have not been linked to a record in Wonde and do not have a Wonde ID. Select the records you wish to delete. The records you keep will be stored without a Wonde ID.</p>

        <div className="LineSpacer5"></div>

        <h4>Select record to delete and click confirm OR click confirm without selecting any to keep these records</h4>

        {listUrl &&
          <InfoTable
            listUrl={listUrl}
            firstColWidth={215}
            firstColWidthSm={110}
            updateListStatus={true}
            setIsPanelClosed={setIsPanelClosed}
            isPanelClosed={isPanelClosed}
            allowSelectAll={true}
            filterTable={false}
            setCheckTableLoading={setCheckTableLoading}
            hideSideMenu={true}
            getSelectedOpts={{ 
              "getOpts": setRecordsSelected, 
              "id": currentSynOpt === "Class" ? 
                "classes__id" :
                currentSynOpt === "Pupil" ?
                "pupils__id" :
                "schoolusers__id"
            }}
            rowHighlight={true}
            hideBtmCtrls={true}
            setTableData={setTableData}
            endpointTableErr={setEndpointTableErr}
          >
          </InfoTable>
        }

        <PreviouslyMatchedRecords currentSynOpt={currentSynOpt} />        

        <div className="BtmBtns">
          <div className="Btn BtnWhite LeftBtn" onClick={() => {
            window.scrollTo(0, 0);
            setWondeIntegration(false);
          }}>Cancel</div>
          {!checkTableLoading &&
            <div className="Btn BtnOrange RightBtn" onClick={() => setDeleteRecordsPopupOpen(true)}>Confirm</div>
          }
        </div>
      </div>

      {deleteRecordsPopupOpen && (
        <DeleteRecordsPopup
          panelOpen={deleteRecordsPopupOpen}
          togglePanelOpen={setDeleteRecordsPopupOpen}
          recordsSelected={recordsSelected}
          setWondeIntegration={setWondeIntegration}
          setCurrentStep={setCurrentStep}
          syncDataOpts={syncDataOpts}
          setSyncDataOpts={setSyncDataOpts}
          submitUrl={submitUrl}
          currentSynOpt={currentSynOpt}
          tableData={tableData}
        />        
      )}      
    </div>
  );
};